var _path, _path2, _path3, _path4, _path5, _path6, _defs;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgCanvaIconlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z",
    fill: "#7D2AE7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z",
    fill: "url(#paint0_radial_1_40)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z",
    fill: "url(#paint1_radial_1_40)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z",
    fill: "url(#paint2_radial_1_40)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z",
    fill: "url(#paint3_radial_1_40)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8152 38.5644C45.5511 38.5644 45.3187 38.7874 45.0769 39.2745C42.3458 44.8125 37.6286 48.731 32.17 48.731C25.8582 48.731 21.9495 43.0333 21.9495 35.1619C21.9495 21.8286 29.3785 14.1195 35.9037 14.1195C38.9527 14.1195 40.8148 16.0357 40.8148 19.0849C40.8148 22.7039 38.7587 24.62 38.7587 25.8964C38.7587 26.4693 39.1151 26.8162 39.8218 26.8162C42.661 26.8162 45.9934 23.5538 45.9934 18.9449C45.9934 14.476 42.1039 11.1912 35.5789 11.1912C24.7951 11.1912 15.2113 21.1888 15.2113 35.0218C15.2113 45.7294 21.3257 52.8051 30.7599 52.8051C40.7734 52.8051 46.5634 42.8423 46.5634 39.6086C46.5634 38.8925 46.1972 38.5644 45.8152 38.5644Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_40",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.3621 56.7242) rotate(-49.4156) scale(49.4986)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6420FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6420FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1_40",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.9432 7.27579) rotate(54.7035) scale(55.8188)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C4CC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1_40",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.3621 56.7242) rotate(-45.1954) scale(48.8994 22.4895)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6420FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6420FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1_40",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.1726 8.62316) rotate(66.5198) scale(50.3869 84.4093)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C4CC",
    stopOpacity: 0.725916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#00C4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C4CC",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvaIconlogo);
export default __webpack_public_path__ + "static/media/Canva Icon logo.221a9e50f3684dc9fbd03f95d18ef286.svg";
export { ForwardRef as ReactComponent };